import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const SystemRoles: FC<ISvG> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.03"
      height="17.356"
      viewBox="0 0 18.03 17.356"
    >
      <g
        id="Group_4192"
        data-name="Group 4192"
        transform="translate(-35 -324.253)"
      >
        <path
          id="Path_791"
          data-name="Path 791"
          d="M328.561,345.933v5.512H314.073v-5.512s3.093-3.378,7.246-3.465C325.467,342.555,328.561,345.933,328.561,345.933Z"
          transform="translate(-279.073 -10.336)"
          fill="#858e95"
        />
        <path
          id="Subtraction_1"
          data-name="Subtraction 1"
          d="M8,8.977H6.481V3.465A11.768,11.768,0,0,0,0,.053,6.71,6.71,0,0,1,.762,0C4.862.085,7.973,3.431,8,3.465Z"
          transform="translate(44.53 332.132)"
          fill="#858e95"
          stroke="rgba(0,0,0,0)"
          strokeMiterlimit="10"
          strokeWidth="1"
        />
        <circle
          id="Ellipse_266"
          data-name="Ellipse 266"
          cx="3.439"
          cy="3.439"
          r="3.439"
          transform="translate(38.805 324.254)"
          fill="#858e95"
        />
        <g
          id="Group_4191"
          data-name="Group 4191"
          transform="translate(45.18 324.253)"
        >
          <path
            id="Path_793"
            data-name="Path 793"
            d="M324.908,334.97a3.418,3.418,0,0,0-1.45.324,3.433,3.433,0,0,1,0,6.23,3.438,3.438,0,1,0,1.45-6.554Z"
            transform="translate(-323.458 -334.97)"
            fill="#858e95"
          />
        </g>
        <path
          id="Path_795"
          data-name="Path 795"
          d="M2043.217,338.092"
          transform="translate(-1994.343 -2.584)"
          fill="#858e95"
        />
        <path
          id="Path_796"
          data-name="Path 796"
          d="M2043.461,338.092"
          transform="translate(-1994.401 -2.584)"
          fill="none"
          stroke="#707070"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export default memo(SystemRoles);
